import { getCurrencyMock } from '@pp/dictionaries';

import { ChangeType, CryptoMarketRate } from './crypto-market.entities';

export function getCryptoMarketMock(): CryptoMarketRate[] {
  return [
    {
      price: '3074601',
      priceCurrency: getCurrencyMock(1, 'fiat'),
      coinCurrency: getCurrencyMock(1, 'crypto'),
      changeTime: {
        percents: '0.75',
        changeType: ChangeType.increase,
      },
      marketCap: 638_465_745_434,
    },
    {
      price: '1897',
      priceCurrency: getCurrencyMock(2, 'fiat'),
      coinCurrency: getCurrencyMock(2, 'crypto'),
      changeTime: {
        percents: '0.35',
        changeType: ChangeType.decrease,
      },
      marketCap: 567_543,
    },
    {
      price: '1',
      priceCurrency: getCurrencyMock(3, 'fiat'),
      coinCurrency: getCurrencyMock(3, 'crypto'),
      changeTime: {
        percents: '0.01',
        changeType: ChangeType.increase,
      },
      marketCap: 45_000_000,
    },
    {
      price: '3074601',
      priceCurrency: getCurrencyMock(1, 'fiat'),
      coinCurrency: getCurrencyMock(1, 'crypto'),
      changeTime: {
        percents: '0.75',
        changeType: ChangeType.increase,
      },
      marketCap: 99_665,
    },
    {
      price: '1897',
      priceCurrency: getCurrencyMock(2, 'fiat'),
      coinCurrency: getCurrencyMock(2, 'crypto'),
      changeTime: {
        percents: '0.35',
        changeType: ChangeType.decrease,
      },
      marketCap: 2_232_323_377,
    },
    {
      price: '1',
      priceCurrency: getCurrencyMock(3, 'fiat'),
      coinCurrency: getCurrencyMock(3, 'crypto'),
      changeTime: {
        percents: '0.01',
        changeType: ChangeType.increase,
      },
      marketCap: 2_232_323_377,
    },
    {
      price: '3074601',
      priceCurrency: getCurrencyMock(1, 'fiat'),
      coinCurrency: getCurrencyMock(1, 'crypto'),
      changeTime: {
        percents: '0.75',
        changeType: ChangeType.increase,
      },
      marketCap: 22_323_233_775,
    },
    {
      price: '1897',
      priceCurrency: getCurrencyMock(2, 'fiat'),
      coinCurrency: getCurrencyMock(2, 'crypto'),
      changeTime: {
        percents: '0.35',
        changeType: ChangeType.decrease,
      },
      marketCap: 2_232_323_377,
    },
    {
      price: '1',
      priceCurrency: getCurrencyMock(3, 'fiat'),
      coinCurrency: getCurrencyMock(3, 'crypto'),
      changeTime: {
        percents: '0.01',
        changeType: ChangeType.increase,
      },
      marketCap: 223_232_337,
    },
    {
      price: '3074601',
      priceCurrency: getCurrencyMock(1, 'fiat'),
      coinCurrency: getCurrencyMock(1, 'crypto'),
      changeTime: {
        percents: '0.75',
        changeType: ChangeType.increase,
      },
      marketCap: 223_232,
    },
    {
      price: '1897',
      priceCurrency: getCurrencyMock(2, 'fiat'),
      coinCurrency: getCurrencyMock(2, 'crypto'),
      changeTime: {
        percents: '0.35',
        changeType: ChangeType.decrease,
      },
      marketCap: 2_232_323_377,
    },
    {
      price: '1',
      priceCurrency: getCurrencyMock(3, 'fiat'),
      coinCurrency: getCurrencyMock(3, 'crypto'),
      changeTime: {
        percents: '0.01',
        changeType: ChangeType.increase,
      },
      marketCap: 22_323_002,
    },
  ];
}
